import Icon from 'Components/icon';
import styled from 'styled-components';

export const StyledInput = styled.input`
	outline: none;
	border: none;

	font-family: Roboto;
	font-size: 12px;
	font-weight: 400;
`;

export const StyledIcon = styled(Icon)`
	color: #595959;
	font-size: 16px;
`;

export const Wrapper = styled.div`
	display: flex;
	align-items: center;
	justify-content: space-between;
	gap: 6px;

	padding: 8px 10px;

	${StyledInput} {
		flex: 1;
	}
`;
